import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';


@Injectable({
  providedIn: 'root'
})
export class AspWarrantyCertificateListService {

  constructor(private http: HttpClient) {}

  getRegisteredPartList(garageKey: string) {

    const paramData = {
      garageKey: garageKey,
      source: "web",
    };

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}/v2/order/registerParts/list`,
      paramData
    );
  }
}
